import { useEffect, useState } from "react";
import useAccount from "../authorization/useAccount";
import useFirestore from "../common/useFirestore";
import { useNavigate } from "react-router-dom";

function useSuccess(id, paymentKey){
    const uid = sessionStorage.getItem("uid");
    const {getCommonUser} = useAccount(uid);
    const {updateFirestore, readFirestoreOneDoc, deleteFirstore} = useFirestore();
    const navigate = useNavigate();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modal, setModal] = useState({
        title:"",
        content:"",
        onConfirmClickHandler:() => {}
    });
    useEffect(() => {
        if(id){
            updateOrderState();
        }
    }, [id])

    const updateOrderState = async() => {
        const user = await getCommonUser();
        if(user){
            const order_item_list = await readFirestoreOneDoc(`Pay/${user.id}/Order`, id).then(res => {
                if(res.exists()){
                    return res.data().item;
                }
                return [];
            })
            if(order_item_list.length){
                for(const item of order_item_list){
                    await deleteFirstore(`Cart/${user.id}/Item`, item.id);
                }
            }
            const result = await updateFirestore(`Pay/${user.id}/Order`, id, {
                payment_key:paymentKey,
                state:"PAIED",
                paied_date: new Date()
            }).then(res => {
                return res;
            })
            if(result){
                setModal({
                    title:"SUCCESS",
                    content:"결제가 완료 되었습니다",
                    onConfirmClickHandler:() => navigate("/profile", {replace:true}),
                })
                setIsOpenModal(true);
            }
        }
    }
    return {isOpenModal, modal}
}

export default useSuccess;